<template>
  <div class="c-conetntsTextarea">
    <c-input-v2
      type="textarea"
      :rows="inputRows"
      :name="requestItem.name"
      :maxlength="requestItem.optionJson.max"
      :minlength="requestItem.optionJson.min"
      :required="requestItem.requiredFlag"
      :placeholder="requestItem.optionJson.placeholder"
      :additional-validations="additionalValidations"
      v-model="inputValue"
      @input="changeInput"
      @validate="validateInput"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ConetntsTextarea',
  props: {
    requestItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      inputValue: this.requestItem.optionJson.content,
      isValid: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    inputRows() {
      if (this.requestItem.name === 'content') {
        // 依頼概要は行数多い
        return this.isPC ? 10 : 8
      }

      return 5
    },
    additionalValidations() {
      if (this.requestItem.name === 'referenceUrl') {
        return ['url']
      }

      return []
    }
  },
  methods: {
    changeInput() {
      this.$emit('change', {
        name: this.requestItem.name,
        value: this.inputValue,
        isValid: this.isValid
      })
    },
    validateInput(isValid) {
      this.isValid = isValid
    }
  }
}
</script>
